var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dynamic-master-layout',[_c('div',{staticClass:"donate-home"},[_c('DonateBanner'),_c('donate-programs'),_c('DonateWays')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }